import * as React from 'react';

function SvgEllipsisVerticalOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.6, d: "M12 13.668a1.667 1.667 0 100-3.334 1.667 1.667 0 000 3.334zM12 22a1.667 1.667 0 100-3.333A1.667 1.667 0 0012 22zM12 5.333A1.667 1.667 0 1012 2a1.667 1.667 0 000 3.333z" })));
}

export default SvgEllipsisVerticalOutline;
